
import React from 'react';
import UpdateMessage from 'views/Trailblazer';

const UpdateMessagePage = () => {
  return <UpdateMessage/>;
};

export default UpdateMessagePage;